import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getServiceType(pathname, queryParams = "") {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams); // pathname is "/role"
}

export async function createServiceType(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/service-type" + pathname, body);
}

export async function updateServiceType(
  pathname,
  queryParams,
  body) {
  return await instance({
    baseURL: baseURL,
  }).post("/service-type" + pathname + queryParams, body);
}

export async function deleteServiceType(pathname, queryParams) {
  return await instance({
    baseURL: baseURL,
  }).post("/service-type" + pathname + queryParams);
}
